module.exports = __webpack_public_path__ + "static/media/dungeon_floor_e.c72d77ba.png";